import { ref } from "@vue/composition-api";
import useEventListener from './useEventListener';

export default function useIPadProDetection() {
  const mediaQuery = window.matchMedia('(min-width: 1025px)');
  const isIPadPro = ref(mediaQuery.matches);

  useEventListener(mediaQuery, 'change', (e) => {
    isIPadPro.value = e.matches;
  });

  return { isIPadPro };
}
